export default function () {

    const rmaForm = document.getElementById('rma_form');
    const rmaSwitcher = document.getElementById('rma_type');

    if (!rmaForm && !rmaSwitcher)
        return;


    document.getElementById("rma_type").addEventListener('input', function (event) {

        var params = new URLSearchParams(location.search);
        params.set('type', event.target.value);
        window.location.search = params.toString();

    }, false);

    document.getElementById('rma_submit_button').disabled = true;


    function RmaValid(selectedProducts) {
        
        if (selectedProducts.length === 0) {
            document.getElementById('rma_error').style.display = 'block';
            document.getElementById('rma_submit_button').disabled = true;

        }
        else {

            document.getElementById('rma_submit_button').disabled = false;
            document.getElementById('rma_error').style.display = 'none';
        }
    }



    const checkboxes = document.querySelectorAll("input[name='positionId']");
    let selectedProducts = [];

    checkboxes.forEach(checkbox => {
        checkbox.addEventListener("change", function () {
            selectedProducts = Array.from(document.querySelectorAll("input[name='positionId']:checked"))
                .map(cb => cb.value);

            RmaValid(selectedProducts);
        });
    });

    /* RmaValid(selectedProducts);*/

    //rmaForm.addEventListener("submit", (event) => {

    //    if (selectedProducts.length === 0) {
    //        event.preventDefault();

    //    }


    //});
}


